// Color system matching the Kotlin MyColors.kt file
export const colors = {
  // Primary colors
  primary: '#1A2B4C',
  primaryDark: '#223B68',
  primaryLight: '#3C5A91',
  primaryTransparent: '#331A2B4C',

  // Accent colors
  accent: '#C9A14B',
  accentLight: '#FFD27A',
  accentDark: '#003217',

  // Grey colors
  grey: '#B0B6BF',
  darkGrey: '#6B7280',
  lightGrey: '#E8E4E4',

  // Basic colors
  white: '#FFFFFF',
  black: '#000000',

  // Status colors
  green: '#2E7D32',
  red: '#D32F2F',
  redLight: '#EF9A9A',
  orange: '#FFA700',

  // Background colors
  backgroundLight: '#F9FAFB',
  backgroundDark: '#0F172A',
};

// Theme-aware color getters
export const getThemeColors = (isDark: boolean) => ({
  primary: isDark ? colors.primaryLight : colors.primary,
  accent: isDark ? colors.accentLight : colors.accent,
  statusBar: isDark ? colors.darkGrey : colors.grey,
  background: isDark ? colors.backgroundDark : colors.backgroundLight,
  surface: isDark ? colors.primaryDark : colors.white,
  textBody: isDark ? colors.grey : colors.black,
  textSubtitles: isDark ? colors.white : colors.black,
  textTitles: isDark ? colors.white : colors.primary,
  textLabels: isDark ? colors.lightGrey : colors.darkGrey,
  iconTint: isDark ? colors.accentLight : colors.accent,
  orange: colors.orange,
  error: colors.red,
});

// Tailwind CSS color classes
export const tailwindColors = {
  primary: {
    50: '#f0f4f8',
    100: '#d9e2ec',
    200: '#bcccdc',
    300: '#9fb3c8',
    400: '#829ab1',
    500: '#627d98',
    600: '#486581',
    700: '#334e68',
    800: '#2d3748',
    900: '#1a2b4c',
  },
  accent: {
    50: '#fef7e0',
    100: '#fdecc1',
    200: '#fbd583',
    300: '#f9be45',
    400: '#f7a707',
    500: '#c9a14b',
    600: '#a17f3a',
    700: '#795d2a',
    800: '#513c1b',
    900: '#291a0d',
  },
  grey: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827',
  },
}; 